class Observer {
    constructor () {
        this.callbackMap = {};
    }

    // 发布事件
    dispatch(event, data) {
        const callbacks = this.callbackMap[event];
        if (callbacks) {
            callbacks.forEach(cb => cb.fn(data));
        }
        return this;
    }

    // 订阅事件
    subscribe(event, cb) {
        const token = Math.ceil(Math.random() * 10 * new Date());
        this.callbackMap[event] ?
            this.callbackMap[event].push({
                eventName: event,
                token,
                fn: cb
            })
            : (this.callbackMap[event] = [{
                eventName: event,
                token,
                fn: cb
            }])
        return {
            this: this,
            token,
            event
        };
    }

    // 取消事件
    unSubscribe(eventName = '', token){
        if(!token && !eventName){
            throw new Error('Parameter Exception，check your token and eventName');
        }
        const _del = (arr) => {
            const index = arr.findIndex(ele => ele.token === token);
            arr.splice(index, 1);
        }
        if(!!eventName && !!token){
            const arr = this.callbackMap[eventName];
            _del(arr);
        } else if(token) {
            const _callbackMap = this.callbackMap;
            for (const key in _callbackMap) {
                if (_callbackMap.hasOwnProperty.call(_callbackMap, key)) {
                    const arr = _callbackMap[key];
                    if(!!arr && !!arr.length){
                        _del(arr);
                        return;
                    }                    
                }
            }
        }
        return this;
    }

};
export default Observer;
export const createObserver = () => {
    window.observer = window.observer ? window.observer : new Observer();// 这里换成优先取window上的observer，是为了让igws和csr两个工程的事件互通
};